import { ProgressBar } from "./Progressbar";

interface StatusInProgressProps {
  percentage: number;
  sortKey?: string | number;
}

export const StatusInProgressCell = ({ percentage }: StatusInProgressProps) => (
  <div style={{ marginTop: "8px" }}>
    <ProgressBar percentage={percentage} />
  </div>
);
